(function() {
    'use strict';

    angular.module('user')
        .controller('LoginUsernameController', LoginUsernameController);

    LoginUsernameController.$inject = ['userAuthService'];

    function LoginUsernameController(userAuthService) {
        var self = this;

        self.credentials = {
            username: '',
            password: ''
        };

        self.serverErrors = {
            username: [],
            password: [],
            nonFieldErrors: []
        };

        self.login = userAuthService.login;
    }
})();
